import { formatDate } from '@/helpers'
import { HistoryColumnsModifiedTypeEnum } from '@/types'

export const getFormattedValue = (
  entity: string,
  columnKey: string,
  type: keyof typeof HistoryColumnsModifiedTypeEnum,
  value: string | number | boolean | null,
  tEnums: (key: string) => string,
) => {
  if (type === 'object') {
    return JSON.stringify(value)
  }

  if (type === 'date' || type === 'datetime') {
    return formatDate(value as string)
  }

  if (type && type === 'bool') {
    return value
      ? tEnums('history_timeline_yes')
      : tEnums('history_timeline_no')
  }

  if (entity === 'sale_order') {
    if (columnKey === 'status') {
      return tEnums(`sale_order_status_${value}`)
    }
  }

  if (entity === 'order_payment') {
    if (columnKey === 'status') {
      return tEnums(`order_payment_status_${value}`)
    }
  }

  if (entity === 'order_invoice') {
    if (columnKey === 'status') {
      return tEnums(`order_invoice_status_${value}`)
    }
  }

  if (entity === 'order_shipment') {
    if (columnKey === 'status') {
      return tEnums(`logistic_shipment_status_${value}`)
    }
  }

  if (entity === 'credit_order') {
    if (columnKey === 'status') {
      return tEnums(`credit_order_status_${value}`)
    }
  }

  if (entity === 'quotation') {
    if (columnKey === 'status') {
      return tEnums(`quotation_status_${value}`)
    }
  }

  if (entity === 'quotation') {
    if (columnKey === 'delivery_option') {
      return tEnums(`logistic_shipment_delivery_option_${value}`)
    }
  }

  if (entity === 'quotation') {
    if (columnKey === 'payment_form_option') {
      return tEnums(`financial_profile_payment_forms_${value}`)
    }
  }

  if (entity === 'quotation') {
    if (columnKey === 'payment_method_option') {
      return tEnums(`financial_profile_transaction_payment_methods_${value}`)
    }
  }

  if (entity === 'supply_order') {
    if (columnKey === 'status') {
      return tEnums(`supply_order_status_${value}`)
    }

    if (columnKey === 'shipment_status') {
      return tEnums(`supply_order_shipment_status_${value}`)
    }

    if (columnKey === 'payment_status') {
      return tEnums(`supply_order_payment_status_${value}`)
    }

    if (columnKey === 'cancellation_reason') {
      return tEnums(`supply_order_status_cancelled_reason_${value}`)
    }
  }

  if (entity === 'supply_order_item') {
    if (columnKey === 'category') {
      return tEnums(`product_quality_category_${value}`)
    }
  }

  return value
}
